import { ButtonFactoryProps } from "@components/Button/utils/types";
import { cn } from "@util/helpers";

export const btnSecondaryStyle = cn(
  "font-poppins text-gray-850 text-xs px-6 py-3 rounded-[3rem] font-semibold transition-colors !no-underline justify-center tracking-2% border border-gray-175 ",
  "hover:border-gray-850 "
);

/** This is the secondary button. */
const ButtonSecondary = ({
  className,
  text,
  icon,
  iconPosition = "right",
  onClick,
}: ButtonFactoryProps): React.ReactElement => {
  return (
    <button
      data-testid="button-secondary-component"
      className={cn(
        btnSecondaryStyle,
        { "aspect-square p-[5px]": icon && typeof text === "undefined" },
        className
      )}
      onClick={onClick}
      type="button"
    >
      {iconPosition === "left" && icon ? icon : null}
      {text ? text : null}
      {iconPosition === "right" && icon ? icon : null}
    </button>
  );
};

export default ButtonSecondary;
